import { Game } from "../Model/Game";
export class GamesFactory {
    constructor(eventsChannelFactory) {
        this.eventsChannelFactory = eventsChannelFactory;
    }
    createGame(id, roomId, code, managerId, creationDate, type, state, waitTime, numbers, useCheckers) {
        return new Game(this.eventsChannelFactory, id, roomId, code, managerId, creationDate, type, state, waitTime, numbers, useCheckers);
    }
    createGameFromDto(dto) {
        return this.createGame(dto.id, dto.roomId, dto.code, dto.managerId, new Date(dto.creationDate), dto.type, dto.state, dto.waitTime, dto.numbers, dto.useCheckers);
    }
}
